import { useContext } from 'react';
import NodeBubbleMenuShell from '../../../components/NodeBubbleMenuShell';
import TableNodeTabContent from './TableNodeTabContent';
import DocumentContext from '../../../contexts/DocumentContext.context';
import { ETiptapSelectorKey } from '../../../types/tiptap.types';

const TableNodeBubbleMenu = () => {
  const { editor, isEdit, isTableMenuOpen, setIsTableMenuOpen } = useContext(DocumentContext);

  return (
    <NodeBubbleMenuShell
      nodeName={ETiptapSelectorKey.TABLE}
      editor={editor}
      isEdit={isEdit}
      isOpen={isTableMenuOpen}
      setIsOpen={setIsTableMenuOpen}
      paddingCard="tight"
      alternativeIsOpen={({ editor: e }) => e.can().mergeCells()}
    >
      <TableNodeTabContent isBubble />
    </NodeBubbleMenuShell>
  );
};

export default TableNodeBubbleMenu;
